export default "__VITE_ASSET__BNVhrbw2__"